<div style="text-align:center;margin-top:20px;" [hidden]="!shown"
    *ngIf="studentSchedules && studentSchedules.length == 0" translate>
    No assignments exist for this student
</div>
<div [hidden]="!shown" *ngIf="studentSchedules && studentSchedules.length > 0"
    style="margin-top:15px;min-width: 1375px;">
    <div #divControls>
        <tyl-form-field style="width: 400px; padding-right: 20px;" label='Course Name'>
            <mat-select id="dropdownCourses" aria-label="Courses dropdown" tabindex="0" [(ngModel)]="selectedCourse"
                (selectionChange)="course_change()">
                <mat-option *ngFor="let course of studentSchedules" [value]="course">
                    <span>{{ course.Course }}</span>
                </mat-option>
            </mat-select>
        </tyl-form-field>

        <tyl-form-field style="width: 250px; padding-right: 20px;" label='Term'>
            <mat-select id="dropdownGradingPeriod" aria-label="Grading Period dropdown" tabindex="1"
                [(ngModel)]="selectedGP" (selectionChange)="gradingPeriod_Change()">
                <mat-option [value]="-1"></mat-option>
                <mat-option *ngFor="let gp of selectedCourse?.CourseTerms" [value]="gp">
                    <span>{{ (gp.OverrideGradingTerm != null && gp.OverrideGradingTerm != '') ? gp.OverrideGradingTerm :
                        gp.LongDescription }}</span>
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>
    <div #divCourseInfo class="divTable" *ngIf='true'>
        <table class="table" style="margin-top:15px;overflow: auto;" *ngIf="!!courseInfo">
            <thead>
                <tr>
                    <th style="display: none;">ID</th>
                    <th style="min-width:125px;" translate>Teacher</th>
                    <th style="min-width:125px;"
                        *ngIf="(courseInfo.GradeParentGrid != null && courseInfo.GradeParentGrid != '')" translate>Grade
                    </th>
                    <th style="min-width:220px;" translate>School</th>
                    <th style="min-width:125px;" translate>Course-Section</th>
                    <th *ngIf="canSendEmail">&nbsp;</th>
                    <th *ngIf="showStandardBasedScore">&nbsp;</th>
                    <th *ngIf="loginSettings.ParentPortalAssignmentsDisplayProfiles">&nbsp;</th>
                    <td *ngIf="loginSettings.ParentPortalAssignmentsDisplayProfiles">&nbsp;</td>
                    <td *ngIf="loginSettings.ParentPortalAssignmentsDisplayProfiles">&nbsp;</td>
                </tr>
            </thead>
            <tbody>
                <tr style="line-height:40px;">
                    <td style="display: none;">{{courseInfo?.AssignmentId}}</td>
                    <td style="min-width:125px;">{{courseInfo?.TeacherName}}</td>
                    <td style="min-width:125px;"
                        *ngIf="(courseInfo.GradeParentGrid != null && courseInfo.GradeParentGrid != '')"
                        class="text-left">
                        <span>{{courseInfo?.GradeParentGrid}}</span>
                    </td>
                    <td style="min-width:230px;">{{courseInfo?.SiteName}}</td>
                    <td style="min-width:125px;">{{courseInfo?.Course}}</td>
                    <td *ngIf="canSendEmail" style="min-width:95px; max-width:105px;">
                        <a class="link" (click)="sendEmail()" translate>Email Teacher</a>
                    </td>
                    <td *ngIf="showStandardBasedScore" style="min-width:125px;">
                        <a (click)="ShowStandardBasedScore(courseInfo?.TeacherName)" class="link" translate>Standards
                            Based Scores</a>
                    </td>
                    <td *ngIf="(loginSettings.EnableClassInformationandTeacherProfiles && selectedCourse.HasClassProfile)"
                        style="min-width:120px;min-width:120px;">
                        <a (click)="classInformation_click()" class="link" translate>Class Information</a>
                    </td>
                    <td *ngIf="(loginSettings.EnableClassInformationandTeacherProfiles && selectedCourse.HasTeacherProfile)"
                        style="min-width:105px;max-width:105px;">
                        <a (click)="teacherProfile_click()" class="link" translate>Teacher Profile</a>
                    </td>
                    <td *ngIf="loginSettings.ParentPortalAssignmentsDisplayProfiles"
                        style="min-width:125px;max-width:125px;">
                        <a (click)="courseDescription_click()" class="link" translate>Course Description</a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div style="text-align:center; margin-top:20px" *ngIf="studentAssignments.length == 0">
        <span translate>No assignments exist for the selected class and term.</span>
    </div>
    <div style="overflow:auto;flex-grow:1;">
        <mat-table #table *ngIf="studentAssignments.length > 0" [dataSource]="angularMatData" multiTemplateDataRows
            matSortDisableClear #sort="matSort" matSort id="StudentAssignmentDataTable" matSortActive="DueDate"
            matSortDirection="desc" aria-label="Student Assignment Table" tabindex="0">

            <ng-container matColumnDef="More">]
                <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;">
                    <span translate>More</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:68px;max-width:68px;text-align:center;">
                    <span *ngIf="showToggleIcon(SA)"
                        [ngClass]="checkExpanded(SA) ? 'detail-row-expanded-icon': 'detail-row-collapsed-icon'"
                        class="material-icons" aria-label="Expand row for more details"></span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DueDateDay">]
                <mat-header-cell *matHeaderCellDef style="min-width:80px; max-width:80px;"></mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:80px; max-width:80px;"
                    [ngClass]="utilityClass.getAssignmentStatusClass(SA.AssignmentStatus)">
                    <div style="width:100%; text-align:right; padding-right:5px;">
                        <span>{{getAssignmentStatus(SA.AssignmentStatus, SA.DueDate)}}</span>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="DueDate">]
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    style="min-width:80px; max-width:80px; justify-content: center;">
                    <span translate>Due</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="DueDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:80px; max-width:80px;"
                    [ngClass]="utilityClass.getAssignmentStatusClass(SA.AssignmentStatus)">
                    <span *ngIf="SA.DueDate != '0001-01-01T00:00:00'">{{SA.DueDate | date:'MM/dd/yy'}}</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="AssignedDateDay">]
                <mat-header-cell *matHeaderCellDef style="min-width:30px; max-width:30px;"></mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:30px; max-width:30px;">
                    <span *ngIf="SA.AssignedDate != '0001-01-01T00:00:00'">{{SA.AssignedDate | date:'E'}}</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="AssignedDate">]
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    style="min-width:100px;max-width:100px; justify-content: center;">
                    <span translate>Assigned</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="AssignedDate" dataType="date">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:100px; max-width:100px;">
                    <span *ngIf="SA.AssignedDate != '0001-01-01T00:00:00'">{{SA.AssignedDate | date:'MM/dd/yy'}}</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Assignment">]
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:180px;"><span
                        translate>Assignment</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="Assignment" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:180px;padding-right:5px;">
                    <div style="width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden">{{SA.Assignment}}
                    </div>
                </mat-cell>
            </ng-container>

            <!-- GradeBookUnit -->
            <ng-container matColumnDef="GradeBookUnit">]
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:80px; max-width:80px;"><span
                        translate>Unit</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="GradeBookUnit" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:80px; max-width:80px;">
                    <div>{{SA.GradeBookUnit}}
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Category">]
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:130px; max-width:130px;">
                    <span *ngIf="loginSettings.ParentPortalAssignmentsShowEffectiveScore" translate>
                        Category-ID
                    </span>
                    <span *ngIf="!loginSettings.ParentPortalAssignmentsShowEffectiveScore" translate>
                        Category
                    </span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="Category" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:130px; max-width:130px;">
                    {{SA.Category}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Possible">]
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:110px;max-width:110px;"
                    class='number-header'>
                    <span translate>Points<br />Possible</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="Possible" dataType="number">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:110px;max-width:110px;" class='number-cell-filter'>
                    <span *ngIf="SA.Possible != -1 && SA.Possible != 0">
                        {{SA.Possible}}
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="EarnedPoints">]
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:100px;"
                    class='number-header'>
                    <span translate>Points<br />Earned</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="EarnedPoints" dataType="number">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:100px;max-width:100px;" class='number-cell-filter'>
                    <span *ngIf="(SA.Earned != 0 || utilityClass.IsValid(SA.Grade))">
                        {{SA.Earned}}
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Percentage">]
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    style="min-width:130px; max-width:130px; text-align:right;" class='number-header'>
                    <span translate>Percentage</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="Percentage" dataType="number">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:130px; max-width:130px; text-align:right;"
                    class='number-cell-filter'>
                    <span *ngIf="(SA.Percentage != 0 || utilityClass.IsValid(SA.Grade))">
                        {{SA.Percentage}}
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="SpecialMark">]
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    style="min-width:110px; max-width: 110px; justify-content: center;">
                    <span translate>Special Mark</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="SpecialMark" dataType="string">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:110px; max-width: 110px; justify-content: center;">
                    {{SA.SpecialMark}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Effective">]
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:110px;max-width:110px;"
                    class='number-header'>
                    <span translate>Effective<br />Score</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="Effective" dataType="number">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA" style="min-width:110px;max-width:110px;" class='number-cell-filter'>
                    <span *ngIf="SA.Effective != 0 || utilityClass.IsValid(SA.Grade)">{{SA.Effective}}</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="Grade">]
                <mat-header-cell *matHeaderCellDef mat-sort-header
                    style="min-width:120px; max-width:120px; justify-content: center;">
                    <span translate>Grade</span>
                    <filter class="mat-filter" [data]="angularMatData" columnName="Grade" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let SA"
                    style="min-width:120px; max-width:120px; justify-content: center; padding-right: 60px;">{{SA.Grade}}
                </mat-cell>
            </ng-container>
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let SA" [attr.colspan]="columnsToDisplay.length" style="width:100%;"
                    class="mat-detail-card">
                    <div *ngIf="angularMatData.checkVisible(SA)">
                        <table style="width:100%;" aria-label="Student Assignment Details Table" tabindex="-1">
                            <tr *ngIf="false">
                                <td colspan="2">
                                    <span class="detail-card-heading" translate>Average Score</span><span
                                        class="detail-card-data">{{SA.AverageScore}}</span>
                                    <span class="detail-card-heading" translate>Highest Score</span><span
                                        class="detail-card-data">{{SA.HighestScore}}</span>
                                </td>
                            </tr>
                            <tr *ngIf="utilityClass.IsValid(SA.Comment)">
                                <td colspan="2" class="detail-card-heading" translate>Comments</td>
                            </tr>
                            <tr *ngIf="utilityClass.IsValid(SA.Comment)" class="detail-card-data">
                                <td colspan="2">
                                    <tyl-quill-text-only [padding]="0" [html]="SA.Comment"></tyl-quill-text-only>
                                </td>
                            </tr>
                            <tr *ngIf="utilityClass.IsValid(SA.Summary)">
                                <td colspan="2" class="detail-card-heading" translate>Summary</td>
                            </tr>
                            <tr *ngIf="utilityClass.IsValid(SA.Summary)">
                                <td class="detail-card-data" colspan="2">{{SA.Summary}}</td>
                            </tr>
                            <tr *ngIf="SA.AttachmentDetail != null && SA.AttachmentDetail.length > 0">
                                <td colspan="2" class="detail-card-heading" translate>Details</td>
                            </tr>
                            <tr *ngIf="SA.AttachmentDetail != null && SA.AttachmentDetail.length > 0">
                                <td colspan="2">
                                    <tyl-quill-text-only class="detail-card-data" [padding]="0"
                                        [html]="SA.AttachmentDetail"></tyl-quill-text-only>
                                </td>
                            </tr>
                            <tr *ngIf="SA.GradeBookObjectives?.length > 0">
                                <td colspan="2">
                                    <div>
                                        <table style="width:50%;">
                                            <thead>
                                                <tr class="detail-card-heading">
                                                    <th style="display: none;">ID</th>
                                                    <th style="min-width: 100px; " translate>Standards</th>
                                                    <th style="min-width: 100px; " translate>Score</th>
                                                </tr>
                                            </thead>
                                            <tbody class="detail-card-data">
                                                <tr style="min-height:40px;"
                                                    *ngFor="let GO of SA.GradeBookObjectives | orderBy: 'SortBy'">
                                                    <td style="display: none;"></td>
                                                    <td ng-class="utilityClass.objectiveLevelClass(GO.Level)"
                                                        style="line-height:1.5em;">{{GO.Standard}}</td>
                                                    <td style="line-height:normal;">
                                                        <div *ngFor=" let SBS of GO.StandardsBasedScores">
                                                            {{ getSBSScore(SBS)}}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="isAttachmentExists(SA.AssignmentId)">
                                <td colspan="2" class="detail-card-heading" translate>Attachments</td>
                            </tr>
                            <tr *ngFor="let attachment of getStudentAttachmentByAssignmentId(SA.AssignmentId)"
                                class="detail-card-data" style="line-height:1.5em;">
                                <td style="width:30%">
                                    <a class="link detail-card-data" (click)="utilityClass.saveFile(attachment)"
                                        translate>{{attachment.DocumentName}}</a>
                                </td>
                                <td style="width:70%">{{attachment.DocumentType}}</td>
                            </tr>
                        </table>
                    </div>
                </td>
            </ng-container>
            <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" id="SAdataHeader"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="SAdataRow{{i}}" tabindex="0"
                [attr.aria-label]="getAriaRow(row)"
                [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                style="padding:0px;overflow: hidden;" matRipple (click)="toggleExpanded(row)"
                (keydown)="rowKeyPress($event, row)">
            </mat-row>
            <mat-row *matRowDef="let row; columns: ['expandedDetail']"
                [@detailExpand]="checkExpanded(row) &&  showToggleIcon(row) ? 'expanded' : 'collapsed'"
                (@detailExpand.start)="$event.toState == 'expanded' ? angularMatData.setVisible(row, true) : null"
                (@detailExpand.done)="$event.toState == 'collapsed' ? angularMatData.setVisible(row, false) : null"
                style="overflow: hidden" class="mat-detail-row">
            </mat-row>
        </mat-table>
    </div>
</div>